import React from 'react';
import { Text } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TheftRecoveryActiveCell(props) {
  const {
    value
  } = props;
  if (!value) return null;
  return /*#__PURE__*/_jsx(Text, {
    variant: "tablePillTheftActive",
    children: "Theft Recovery Active"
  });
}